<template>
  <card>
    <template #header>
      <card-header>
        {{$t("homes.patentsTop10")}}
        <template #action>
          <el-link type="primary" :underline="false" @click="more">
            {{ $t("global.more") }}
            <i class="el-icon-arrow-right" style="color:#999999;" />
          </el-link>
        </template>
      </card-header>
    </template>
    <div class="chart">
      <chart id="chart3" ref="top10Chart" @chartClick="click" :options="options" />
    </div>
  </card>
</template>

<script>
import { patentsInTopTenCountries } from "@/api/homes";
export default {
  components: {},
  mixins: [],
  props: {
    autoLoad: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      xAxis: [],
      Values: [],
      currentCompanyId: null
    };
  },
  computed: {
    lang() {
      return this.$store.state.app.language;
    },
    options() {
      return {
        color: ["#3DA4DD"],
        legend: {
          show: false
        },
        title: {
          show: false
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
            shadowStyle: {
              color: "rgba(61,164,211,0.1)"
            }
          }
        },
        grid: {
          top: 5,
          left: 0,
          right: 0,
          bottom: 0,
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: this.xAxis,
            axisLine: {
              lineStyle: {
                color: "#E5E5E5"
              }
            },
            axisLabel: {
              color: "#999999",
              interval:0,
              formatter:function(params){
                if(params.length > 6){
                  return params.substring(0,5) + "..."
                }else{
                  return params
                }
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLine: {
              lineStyle: {
                color: "#E3E3E3"
              }
            },
            axisLabel: {
              color: "#999999"
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#E9E9E9",
                type: "dashed"
              }
            }
          }
        ],

        series: [
          {
            name: "Top10",
            type: "bar",
            barWidth: "60",
            data: this.Values,
            itemStyle: {}
          }
        ]
      };
    }
  },
  watch: {
    lang() {
      this.loadData(this.currentCompanyId);
    }
  },
  created() {
    if (this.autoLoad) {
      this.loadData(this.currentCompanyId);
    }
  },
  mounted() {},
  destroyed() {},
  methods: {
    loadData(companyId) {

      this.currentCompanyId = companyId;

      // if (companyId !== undefined && companyId != null && companyId !== "") {
      //   this.currentCompanyId = companyId;
      // }

      patentsInTopTenCountries(this.currentCompanyId).then(resp => {
        const data = resp.data;

        this.xAxis = data.names;
        this.Values = data.values;

        this.$refs.top10Chart.setOption(this.options);
      });
    },
    click(params) {
      this.$router.push({
        path: "/patentManagement/patentListView",
        query: { countryCode: params.data.code, mainType: 1 }
      });
    },
    more() {
      //this.$router.push({ path: "/patentManagement/patentListView"});
      this.$emit("more")
    }
  }
};
</script>
<style  scoped>
.chart {
  height: 170px;
}
</style>
